import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

// same styles as buttons

const LinkButton = styled(NavLink)(
  ({ theme }) => css`
    display: inline-block;
    margin: ${theme.margins.default};
    font-weight: 600;
    font-size: ${theme.buttons.fontSize};
    border-radius: ${theme.buttons.borderRadius};
    cursor: pointer;

    &.disabled {
      color: ${theme.buttons.disabled.color};
      background-color: ${theme.buttons.disabled.background};
      border: ${theme.buttons.disabled.border};
      cursor: auto;

      @media (hover: hover) {
        &:hover {
          color: ${theme.buttons.disabled.color};
          background-color: ${theme.buttons.disabled.background};
        }
      }
    }
  `
);

const PrimaryLinkButton = styled(LinkButton)(
  ({ theme }) => css`
    color: ${theme.buttons.primary.color};
    background-color: ${theme.buttons.primary.background};
    border: ${theme.buttons.primary.border};
    padding: ${theme.buttons.primary.padding};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.primary.colorHover};
        background-color: ${theme.buttons.primary.backgroundHover};
      }
    }
  `
);

const SecondaryLinkButton = styled(LinkButton)(
  ({ theme }) => css`
    color: ${theme.buttons.secondary.color};
    background-color: ${theme.buttons.secondary.background};
    border: ${theme.buttons.secondary.border};
    padding: ${theme.buttons.secondary.padding};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
  `
);

const PrimaryAltLinkButton = styled(LinkButton)(
  ({ theme }) => css`
    color: ${theme.buttons.primaryAlt.color};
    background-color: ${theme.buttons.primaryAlt.background};
    border: ${theme.buttons.primaryAlt.border};
    padding: ${theme.buttons.primaryAlt.padding};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.primaryAlt.colorHover};
        background-color: ${theme.buttons.primaryAlt.backgroundHover};
      }
    }
  `
);

const SecondaryAltLinkButton = styled(LinkButton)(
  ({ theme }) => css`
    color: ${theme.buttons.secondaryAlt.color};
    background-color: ${theme.buttons.secondaryAlt.background};
    border: ${theme.buttons.secondaryAlt.border};
    padding: ${theme.buttons.secondaryAlt.padding};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondaryAlt.colorHover};
        background-color: ${theme.buttons.secondaryAlt.backgroundHover};
      }
    }
  `
);

type IconLinkButtonProps = {
  iconType: 'Apply' | 'Email';
  href: string;
  size?: string;
  target?: string;
};

const StyledIconLinkButton = styled.a<IconLinkButtonProps>(
  ({ theme, iconType, size }) => css`
    color: ${theme.colors.main.accent};
    padding: 0 0.25rem;
    border: 0;
    background-color: transparent;
    opacity: 0.75;
    transition: opacity 0.35s ease !important;

    .material-symbols-rounded {
      font-size: ${size || '20px'};
    }

    @media (hover: hover) {
      &:hover {
        opacity: 1;
        cursor: pointer;
      }
    }

    ${iconType === 'Apply' &&
    css`
      color: ${theme.colors.main.secondary};
    `}
  `
);

const IconLinkButton = ({
  iconType,
  href,
  size,
  target
}: IconLinkButtonProps) => {
  return (
    <StyledIconLinkButton
      iconType={iconType}
      href={href}
      size={size}
      target={target}
    >
      {iconType === 'Apply' && (
        <span className="material-symbols-rounded no-fill">export_notes</span>
      )}
      {iconType === 'Email' && (
        <span className="material-symbols-rounded no-fill">
          forward_to_inbox
        </span>
      )}
    </StyledIconLinkButton>
  );
};

export {
  PrimaryLinkButton,
  SecondaryLinkButton,
  PrimaryAltLinkButton,
  SecondaryAltLinkButton,
  IconLinkButton
};
